var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bar-chart',{attrs:{"height":_vm.height,"chart-data":_vm.chartConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }